import { makeStyles } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { dataService } from "../../../Services/data/data.service";
import DividerImage from "../../../Images/line2.png";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

// Styling
import "react-toastify/dist/ReactToastify.css";
import "./Assets/styles/landingpage-styles.css";

// JS
import "https://cdnjs.cloudflare.com/ajax/libs/gsap/latest/TweenLite.min.js";

// Components
import CanvasAnimation from "./Components/CanvasAnimation";

// Images
import img_logo from "./Assets/images/logo.png";
import img_bannerBg from "./Assets/images/Banner_BG.png";
import img_arrowRight from "./Assets/images/arrow-right.png";
import img_circleLeft from "./Assets/images/circle-left.png";
import img_circleRight from "./Assets/images/circle-right.png";
import img_shapeIcon1 from "./Assets/images/shape_icon1.png";
import img_shapeIcon2 from "./Assets/images/shape_icon2.png";
import img_shapeIcon3 from "./Assets/images/shape_icon3.png";
import img_shapeIcon4 from "./Assets/images/shape_icon4.png";
import img_shapeIcon5 from "./Assets/images/shape_icon5.png";
import img_icon1 from "./Assets/images/icon-1.png";
import img_icon2 from "./Assets/images/icon-2.png";
import img_icon3 from "./Assets/images/icon-3.png";
import img_icon4 from "./Assets/images/icon-4.png";
import img_icon5 from "./Assets/images/icon-5.png";
import img_icon6 from "./Assets/images/icon-6.png";
import img_img1 from "./Assets/images/img-1.jpg";
import img_img2 from "./Assets/images/img-2.jpg";
import img_img3 from "./Assets/images/img-3.jpg";
import img_img4 from "./Assets/images/img-4.jpg";
import img_testimonial from "./Assets/images/testimonial.jpg";
import img_goldenCrustLogo from "./Assets/images/golden-crust/GoldenCrust_logo.png";
import img_goldenCrustBanner from "./Assets/images/golden-crust/golden-crust-banner.jpg";

function LandingPage(props) {
  const classes = useStyles();
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [email, setEmail] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const gotoLogin = () => {
    navigate("/login");
  };
  const requestLogin = () => {
    const errors = {};
    if (lastName === null) {
      errors.lastName = "Required";
    }
    if (firstName === null) {
      errors.firstName = "Required";
    }
    if (email === null) {
      errors.email = "Required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      errors.email = "Invalid email address";
    }

    if (Object.keys(errors).length > 0) {
      return errors;
    } else {
      dataService.requestLogin(firstName, lastName, email).then((response) => {
        if (response.success === true) {
          toast.success("Uw aanvraag werd verzonden! Wij nemen zo snel mogelijk contact op met u!", { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
        } else {
          toast.error("Er liep iets verkeerd, probeer opnieuw.", { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
        }
      });
    }
  };

  const handleFirstNameChange = (event) => {
    setFirstName(event.target.value);
  };
  const handleLastNameChange = (event) => {
    setLastName(event.target.value);
  };
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  return (
    <div className="landingpage" style={{ backgroundColor: "white" }}>
      <header className="header">
        <div className="container">
          <div className={classes.navbar_start}>
            <div className="logo">
              <Link to="/">
                <img src={img_logo} alt="" />
              </Link>
            </div>
            <Link to="/pricing" className={classes.navLink}>
              Pricing
            </Link>
          </div>
          <Link className="btn_design" to="/login">
            Login
          </Link>
        </div>
      </header>
      <section className="banner">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="banner_left">
                <h1>
                  Taplr<span>.</span>
                </h1>
                <h4>Uncover Hidden Inefficiencies - Boost Margins by Up to 20%</h4>
                <h5>Taplr connects production data with financial logic to reveal value leaks across your operations.</h5>
                <p>
                  It works on top of your existing ERP, MES, and BI systems — exposing what they miss. In a representative use case, a manufacturer uncovered over €743,000 in hidden costs within
                  weeks.
                </p>
                <Link className="btn_design" to="/bookdemo">
                  Book a Demo
                </Link>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="banner-right">
                <img src={img_bannerBg} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="problem">
        <div className="container">
          <h2 className="h2">The Problem:</h2>
          <div className="cercle">
            <img className="circle-left" src={img_circleLeft} alt="" />
            <img className="circle-right" src={img_circleRight} alt="" />
            <div className="icon_animation">
              <img className="icon_one" src={img_shapeIcon1} alt="" />
              <img className="icon_two" src={img_shapeIcon2} alt="" />
              <img className="icon_three" src={img_shapeIcon3} alt="" />
              <img className="icon_four" src={img_shapeIcon4} alt="" />
              <img className="icon_five" src={img_shapeIcon5} alt="" />
            </div>

            <div id="large-header" className="large-header">
              {/* <canvas id="demo-canvas"> */}
              <CanvasAnimation />
              {/* </canvas> */}
            </div>

            <h3>Finance vs. Production</h3>
            <p>
              It's common in many companies that finance and production teams aren't perfectly aligned. As a result, it's hard to see where exactly to improve operations to have a real impact on the
              bottom line.
            </p>
            <p>Taplr solves this problem by combining task mining with financial insights, allowing you to track production data while seeing the real financial impact of your decisions.</p>
            <div className="video-container">
              <iframe
                src="https://www.youtube.com/embed/QG386Ay49ME?autoplay=0&mute=1&controls=1&loop=1"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <Link className="btn_design" to="/bookdemo">
              Experience it for yourself
            </Link>
          </div>
        </div>
      </section>
      {/* What Taplr Adds */}
      <section className="what-taplr-adds">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="what-taplr-adds_top text-center">
                <h2>Aren't tools like OEE, Lean and digital workfloor solutions enough?</h2>
                <p>
                  Most factories already use tools like OEE dashboards, Lean routines, and digital checklists to drive efficiency. And rightly so — they're great for spotting big problems and
                  structuring improvements. But what happens when the obvious gains are gone? When your teams are already working hard, and improvements become incremental at best?
                </p>
                <h3>That's where Taplr comes in.</h3>
                <p>
                  We don't replace these methods — we strengthen them. Taplr zooms in on real-time, task-level friction that often goes unnoticed. It quantifies inefficiencies you can't see in your
                  OEE. It reveals what's silently dragging down your output or profitability — even in a plant that seems to be running just fine.
                </p>
                <h3>But the real game-changer? Taplr adds a financial lens.</h3>
                <p>
                  By linking every inefficiency to its financial impact, Taplr helps you prioritise what really matters, build a solid business case, and secure faster buy-in from both operations and
                  finance. No more guesswork. Just clear, quantified improvement — with ROI in full view.
                </p>
              </div>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-lg-12">
              <div className="what-taplr-adds_benefits">
                <div className="benefits_list">
                  <div className="media">
                    <img className="mr-3" src={img_icon1} alt="" />
                    <div className="media-body">
                      <h4 className="mt-0">Live cost per workstation, event, and order</h4>
                    </div>
                  </div>
                </div>
                <div className="benefits_list">
                  <div className="media">
                    <img className="mr-3" src={img_icon2} alt="" />
                    <div className="media-body">
                      <h4 className="mt-0">Visual P&L at operational level</h4>
                    </div>
                  </div>
                </div>
                <div className="benefits_list">
                  <div className="media">
                    <img className="mr-3" src={img_icon3} alt="" />
                    <div className="media-body">
                      <h4 className="mt-0">Simulation of what-if scenarios</h4>
                    </div>
                  </div>
                </div>
                <div className="benefits_list">
                  <div className="media">
                    <img className="mr-3" src={img_icon4} alt="" />
                    <div className="media-body">
                      <h4 className="mt-0">Insights into hidden inefficiencies</h4>
                    </div>
                  </div>
                </div>
                <div className="benefits_list">
                  <div className="media">
                    <img className="mr-3" src={img_icon5} alt="" />
                    <div className="media-body">
                      <h4 className="mt-0">Set-up in hours — no ERP/MES changes required</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* What taplr adds */}
      <section className="benefits">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="benefits_contain">
                <h2>
                  Benefits for <br /> CFOs:
                </h2>
                <div className="benefits_contain_list">
                  <div className="media">
                    <img className="mr-3" src={img_icon1} alt="" />
                    <div className="media-body">
                      <h4 className="mt-0">
                        See the <br /> Financial Impact:
                      </h4>
                    </div>
                  </div>
                  <p>
                    Taplr shows you how operational changes affect the <br /> bottom line, so you can make smarter financial decisions.
                  </p>
                </div>
                <div className="benefits_contain_list">
                  <div className="media">
                    <img className="mr-3" src={img_icon3} alt="" />
                    <div className="media-body">
                      <h4 className="mt-0">
                        Reduce <br /> Costs:
                      </h4>
                    </div>
                  </div>
                  <p>
                    Pinpoint inefficiencies and reduce waste, leading to <br /> direct cost savings.
                  </p>
                </div>
                <div className="benefits_contain_list">
                  <div className="media">
                    <img className="mr-3" src={img_icon5} alt="" />
                    <div className="media-body">
                      <h4 className="mt-0">
                        Improve Financial <br /> Transparency:
                      </h4>
                    </div>
                  </div>
                  <p>
                    Taplr gives you a clear view of how production <br /> performance aligns with financial goals.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="benefits_contain">
                <h2>
                  Benefits for Process <br /> Improvement Specialists:
                </h2>
                <div className="benefits_contain_list">
                  <div className="media">
                    <img className="mr-3" src={img_icon2} alt="" />
                    <div className="media-body">
                      <h4 className="mt-0">
                        Identify Bottlenecks <br /> Quickly:
                      </h4>
                    </div>
                  </div>
                  <p>
                    Taplr’s real-time data helps you spot production issues <br /> before they become big problems.
                  </p>
                </div>
                <div className="benefits_contain_list">
                  <div className="media">
                    <img className="mr-3" src={img_icon4} alt="" />
                    <div className="media-body">
                      <h4 className="mt-0">
                        Optimize <br /> Operations:
                      </h4>
                    </div>
                  </div>
                  <p>
                    Use task mining to improve workflows and boost <br /> productivity.
                  </p>
                </div>
                <div className="benefits_contain_list">
                  <div className="media">
                    <img className="mr-3" src={img_icon6} alt="" />
                    <div className="media-body">
                      <h4 className="mt-0">
                        Make Informed <br /> Decisions:
                      </h4>
                    </div>
                  </div>
                  <p>
                    Taplr shows both operational and financial data, helping <br /> you prioritize changes that make the biggest impact.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="egest">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="egest_top text-center">
                <h2>Uncover hidden profit leaks with Taplr's task mining & P&L insights</h2>
                <p>
                  Automatically discover how work is actually performed, map it to your financial data, and pinpoint areas where profit is being lost. Empower your team with actionable insights to
                  optimize processes, reduce costs, and drive revenue growth
                </p>
              </div>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-lg-6 margin_bottom">
              <div className="egest_set">
                <div className="media">
                  <img className="ml-3" src={img_img1} alt="" />
                  <div className="media-body">
                    <h3>P&L</h3>
                    <p>
                      Would you make decisions faster if you could prioritize and reassess the impact of continuous improvement with real-time data instantly reflected in your profit and loss
                      statement?
                    </p>
                    <Link to="/bookdemo">
                      Tell me more <img src={img_arrowRight} alt="" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 margin_bottom">
              <div className="egest_set">
                <div className="media">
                  <img className="ml-3" src={img_img2} alt="" />
                  <div className="media-body">
                    <h3>Object Tracking</h3>
                    <p>Would meetings be more efficient and decisions made faster if you could visualize the execution time of your production steps across different processes?</p>
                    <Link to="/bookdemo">
                      Tell me more <img src={img_arrowRight} alt="" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 margin_bottom">
              <div className="egest_set">
                <div className="media">
                  <img className="ml-3" src={img_img3} alt="" />
                  <div className="media-body">
                    <h3>Event visualization</h3>
                    <p>How would your EBIT be impacted if you could quickly pinpoint the origin of delays and identify improvement potential on your shopfloor?</p>
                    <Link to="/bookdemo">
                      Tell me more <img src={img_arrowRight} alt="" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 margin_bottom">
              <div className="egest_set">
                <div className="media">
                  <img className="ml-3" src={img_img4} alt="" />
                  <div className="media-body">
                    <h3>Optimization Insights</h3>
                    <p>What if you could identify low-hanging fruit for improvements, minimize production time by analyzing lost time, and boost your contribution margin with minimal investments?</p>
                    <Link to="/bookdemo">
                      Tell me more <img src={img_arrowRight} alt="" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="stories">
                <div className="stories_top">
                    <div className="container">
                        <h3>Success Stories</h3>
                    </div>
                </div>
                <div className="stories_bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="stories_bottom_left">
                                    <p>Pellentesque id libero ac arcu ornare vehicula. Vestibulum feugiat eu eros vitae scelerisque. Nam volutpat porttitor arcu ac tristique.</p>
                                    <h4>Accountant</h4>
                                    <h5>Robben Stewart</h5>
                                    <img src={img_testimonial} alt="" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="stories_bottom_right">
                                    <ul>
                                        <li>
                                            <h4>Curabitur vehicula neque in nibh <br /> condimentum</h4>
                                            <p>John Doe</p>
                                        </li>
                                        <li>
                                            <h4>Curabitur vehicula neque in nibh <br /> condimentum</h4>
                                            <p>Nancy William</p>
                                        </li>
                                        <li>
                                            <h4>Curabitur vehicula neque in nibh <br /> condimentum</h4>
                                            <p>Alexis Sanchez</p>
                                        </li>

                                    </ul>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
      <section className="success-stories">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="what-taplr-adds_top text-center">
                <h2>Success Stories</h2>
              </div>
            </div>
          </div>
          <div className="row story-row">
            {/* Left Column */}
            <div className="col-lg-6">
              <div className="success-stories-content">
                <div>
                  <div className="case-category">Frozen Food | Representative Use Case</div>

                  {/* Logo + Title */}
                  <div className="case-header">
                    <img src={img_goldenCrustLogo} alt="Golden Crust logo" className="case-logo" />
                    <span className="case-title">Golden Crust Case</span>
                  </div>

                  {/* Case Summary */}
                  <h3 className="case-summary">Representative Case: €743K in Hidden Losses Uncovered</h3>

                  {/* Key Insights */}
                  <ul className="case-insights">
                    <li>Critical inefficiencies found in a high-volume frozen food line</li>
                    <li>€305K/year in downtime losses — undetected by ERP</li>
                    <li>Reject patterns projected to reduce by up to 30%</li>
                    <li>Setup in 2 days — no integration required</li>
                  </ul>
                </div>

                {/* CTA */}
                <a href="/food-industry/" className="case-cta">
                  See the full approach →
                </a>
              </div>
            </div>

            {/* Right Column (Image) */}
            <div className="col-lg-6">
              <div className="success-stories-image">
                <img src={img_goldenCrustBanner} alt="Frozen fries on industrial line" />
                <div className="image-caption">*Based on a representative use case in frozen food production (10 lines, 1 week, no integration).</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="brains-behind-taplr">
        <div className="container">
          <h2>The brains behind Taplr</h2>
          <p>
            At Taplr, we are driven by a passion for innovation and a commitment to helping manufacturers unlock their full potential. Our founder, Jurgen Dekeyser, brings over 25 years of experience
            in improving manufacturing flows across various sectors. Watch the video below to learn more about the vision and values that guide Taplr.
          </p>
          <div className="video-container">
            <iframe
              src="https://www.youtube.com/embed/TjKGYSwPlBY?autoplay=0&mute=1&controls=1&loop=1"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </section>
      <section className="ready text-center">
        <div className="container">
          <h2>Experience Taplr in Action</h2>
          <h4>Want to see how Taplr can work for you?</h4>
          <p>Experience Taplr in action with a live 15-minute simulation. See how real-time cost tracking and financial insights can transform your production processes."</p>
          <Link className="btn_design" to="/bookdemo">
            Book Your Free Simulation Now!
          </Link>
        </div>
      </section>
      <section className="about text-center">
        <div className="container">
          <p>
            Taplr is a product of Flagstone, a company with over 20 years of experience in optimizing shopfloors. Flagstone specializes in identifying inefficiencies and implementing solutions that
            enhance productivity and operations. The process begins with a thorough mapping of all relevant data, serving as the foundation for a detailed evaluation. By analyzing this data, it is
            possible to determine which processes are best suited for digitalization or automation, or where changes to work methods are needed to improve efficiency.
          </p>
          <p>
            Leveraging the insights and expertise Flagstone has gained, Taplr provides an innovative solution for mapping shopfloors and improving operational processes. Taplr helps businesses through
            real-time data analysis and process optimization, balancing both technology and human factors. This creates a dynamic work environment that is not only more efficient but also better
            aligned with the specific needs of the workforce. With this holistic approach Taplr has already helped numerous organizations achieve sustainable improvements and optimization of their
            operational processes.
          </p>
        </div>
      </section>
      <footer className="footer">
        <div className="container">
          <p>
            © 2025 <Link to="/"> Taplr </Link>. All rights reserved. Taplr is a product by Flagstone BV, Stedestraat 51, 8530 Harelbeke - Belgium. <Link to="/privacypolicy">Privacy Policy</Link>
          </p>
        </div>
      </footer>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: "#231F20",
    paddingTop: "65px",

    [theme.breakpoints.down("lg")]: {
      paddingTop: "20px",
    },
  },

  container: {
    maxWidth: "1560px",

    margin: "0 auto",
    padding: "0 15px",
    boxSizing: "border-box",
  },

  navbar_start: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "48px",
    padding: "0 15px",
    boxSizing: "border-box",
    height: "100%",
    [theme.breakpoints.down("lg")]: {
      padding: "0 10px",
    },
    [theme.breakpoints.down("md")]: {
      padding: "0 5px",
    },
  },

  navLink: {
    color: "#fff",
    fontSize: "18px",
    fontWeight: "500",
    textDecoration: "none",
    padding: "0 15px",
    boxSizing: "border-box",
    "&:hover": {
      color: "#fff",
      textDecoration: "underline",
    },
  },

  row: {
    display: "flex",
    flexWrap: "wrap",
    [theme.breakpoints.down("md")]: {
      marginBottom: "30px",
    },
  },

  col5: {
    flex: "0 0 41.666%",
    maxWidth: "41.666%",
    [theme.breakpoints.down("md")]: {
      flex: "0 0 100%",
      maxWidth: "100%",
    },
  },

  col6: {
    flex: "0 0 50%",
    maxWidth: "50%",
    [theme.breakpoints.down("md")]: {
      flex: "0 0 100%",
      maxWidth: "100%",
    },
  },

  col7: {
    flex: "0 0 58.333%",
    maxWidth: "58.333%",
    [theme.breakpoints.down("md")]: {
      flex: "0 0 100%",
      maxWidth: "100%",
    },
  },

  logo: {
    // image inside
    "& img": {
      [theme.breakpoints.down("md")]: {
        width: "130px",
      },

      [theme.breakpoints.down("sm")]: {
        width: "118px",
      },
    },
  },

  banner: {
    padding: "30px 0 110px",
    backgroundColor: "#231F20",
    boxSizing: "border-box",

    [theme.breakpoints.down("lg")]: {
      padding: "30px 0 70px",
    },

    [theme.breakpoints.down("md")]: {
      padding: "0px 0 70px",
      marginTop: "-1px",
    },
  },
}));
export default LandingPage;
